/* CoolFoot – (1) kötelező ÁSZF elfogadás CSAK a kosárnál, (2) „Kosárba” gombfelirat */
(function () {
  'use strict';

  var TERMS_URL = '/pages/aszf';
  var PRIVACY_URL = '/policies/privacy-policy';
  var LABEL_HTML =
    'Elolvastam és elfogadom az <a href="' + TERMS_URL + '" target="_blank" rel="noopener">Általános Szerződési Feltételeket</a>' +
    ' és az <a href="' + PRIVACY_URL + '" target="_blank" rel="noopener">Adatkezelési tájékoztatót</a>.';
  var WARN_TEXT = 'A megrendelés leadásához el kell fogadnod az ÁSZF-et.';

  var CHECKOUT_SELECTOR = [
    '[name="checkout"]',
    'a[href$="/checkout"]',
    'a[href*="/checkouts"]',
    '.cart__checkout-button'
  ].join(', ');

  var CART_CONTEXT = [
    'cart-drawer-component',
    'cart-items-component',
    '#cart-drawer',
    '[class*="cart-drawer"]',
    '[id*="cart-drawer"]',
    '.cart',
    '.cart__ctas',
    '.cart-page',
    'form[action$="/cart"]',
    'form[action*="/cart?"]'
  ].join(', ');

  /* A termékoldalon NEM kérünk ÁSZF checkboxot – csak a kosárban / kosárfiókban. */
  function cartContextOf(el) {
    var ctx = el.closest(CART_CONTEXT);
    if (!ctx) return null;
    if (el.closest('product-form-component, .product-form, [id^="ProductForm"]')) return null;
    return ctx;
  }

  function visibleBoxes() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.cf-terms__input'),
      function (b) { return b.offsetParent !== null; }
    );
  }

  function isAccepted() {
    var boxes = visibleBoxes();
    if (!boxes.length) return true; /* nincs látható checkbox → ne blokkoljunk */
    return boxes.some(function (b) { return b.checked; });
  }

  function showWarning() {
    document.querySelectorAll('.cf-terms__warn').forEach(function (w) { w.classList.add('is-visible'); });
    var box = visibleBoxes()[0];
    if (box) { try { box.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} }
  }

  function buildBlock() {
    var id = 'cf-terms-' + Math.random().toString(36).slice(2, 8);
    var wrap = document.createElement('div');
    wrap.className = 'cf-terms-wrap';

    var row = document.createElement('div');
    row.className = 'cf-terms';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'cf-terms__input';
    input.id = id;

    var label = document.createElement('label');
    label.setAttribute('for', id);
    label.innerHTML = LABEL_HTML;

    row.appendChild(input);
    row.appendChild(label);

    var warn = document.createElement('div');
    warn.className = 'cf-terms__warn';
    warn.textContent = WARN_TEXT;

    wrap.appendChild(row);
    wrap.appendChild(warn);

    input.addEventListener('change', function () {
      if (input.checked) {
        document.querySelectorAll('.cf-terms__warn').forEach(function (w) { w.classList.remove('is-visible'); });
      }
    });

    return wrap;
  }

  function insertCheckboxes() {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (btn) {
      var ctx = cartContextOf(btn);
      if (!ctx || ctx.querySelector('.cf-terms-wrap')) return;

      var anchor = btn;
      var group = btn.closest('[class*="ctas"], [class*="buttons"], [class*="checkout"]');
      if (group && group !== btn && ctx.contains(group)) anchor = group;
      if (anchor.parentElement) anchor.parentElement.insertBefore(buildBlock(), anchor);
    });
  }

  /* „Kosárba” gombfelirat magyarul */
  var ATC_SELECTOR = 'add-to-cart-component button, [name="add"], .product-form__submit, button[data-add-to-cart]';
  var ATC_MATCH = /^(add to cart|add to bag|hozzáadás a kosárhoz|kosárba tesz|kosárba helyezés)$/i;
  function relabelAddToCart() {
    document.querySelectorAll(ATC_SELECTOR).forEach(function (btn) {
      var nodes = btn.querySelectorAll('span, .add-to-cart-text, [class*="button__text"]');
      var targets = nodes.length ? nodes : [btn];
      targets.forEach(function (n) {
        if (n.querySelector('*')) return;
        var t = (n.textContent || '').trim();
        if (ATC_MATCH.test(t)) n.textContent = 'Kosárba';
      });
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var btn = target.closest(CHECKOUT_SELECTOR);
    if (!btn || !cartContextOf(btn)) return;
    if (isAccepted()) return;
    e.preventDefault(); e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    showWarning();
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    if (form.action.indexOf('/cart') === -1 && form.action.indexOf('/checkout') === -1) return;
    if (form.querySelector('[name="add"]')) return; /* termék űrlap */
    if (isAccepted()) return;
    e.preventDefault(); e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    showWarning();
  }, true);

  function init() { insertCheckboxes(); relabelAddToCart(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () { scheduled = false; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
